export const REVIEW_POST_SUCCESS = 'REVIEW_POST_SUCCESS'
export const REVIEW_POST_FAILED = 'REVIEW_POST_FAILED'
export const REVIEW_POST_CLEAR = 'REVIEW_POST_CLEAR'

export const clearReviewState = () => {
  return (dispatch) => {
    dispatch({ type: 'REVIEW_POST_CLEAR' })
  }
}

const initialState = {
  isReviewAdded: "",
  message: ""
}

export default function learnerCourseReviewReducer(state = initialState, action) {
  switch (action.type) {
    case REVIEW_POST_SUCCESS:
      return {
        ...state,
        isReviewAdded: "success"
      }
    case REVIEW_POST_FAILED:
      return {
        ...state,
        isReviewAdded: "failed",
        message: action.message
      }
    case REVIEW_POST_CLEAR:
      return {
        ...state,
        isReviewAdded: "",
        message: ""
      }
    default:
      return state
  }
}
